import React, { useState } from 'react';
import { translate } from '../Services/translation';

const CompareButton = ({
  label,
  title,
  cssClass,
  productId,
  onClick,
  comparedProducts,
  showCompareButtonErrorAction,
  showCompareButtonError,
}) => {
  const [error, setError] = useState(null);
  const product = comparedProducts
    ? comparedProducts.find((item) => item.productId === productId)
    : undefined;

  const onClickButton = (productId) => {
    if (comparedProducts && comparedProducts.length > 3) {
      showCompareButtonErrorAction(
        <div className="compare-error">
          {translate('product.error.exceeded_number_of_items')}
        </div>
      );
    } else if (product) {
      showCompareButtonErrorAction(
        <div className="compare-error">
          {translate('product.error.product_already_added')}
        </div>
      );
    } else {
      onClick(productId);
    }
  };

  return (
    <div>
      <button
        className={`flex items-center gap-2 ${cssClass}`}
        type="button"
        title={title}
        onClick={() => onClickButton(productId)}
      >
        <span className="icon icon-outlined text-accent" aria-hidden="true">compare_arrows</span>
        <span className="text-accent text-sm font-bold uppercase">{label}</span>
      </button>
      {showCompareButtonError}
    </div>
  );
};

export default CompareButton;
